import React, { Component } from "react";
// import { Redirect } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { css } from "react-emotion";
import API from "@aws-amplify/api";
import aws_exports from "../../aws-exports";
import Amplify from "aws-amplify";
import { connect } from "react-redux";
import Header from "../../common/header";
import Footer from "../../common/footer";
import SelectRecordModal from "../Modal/selectRecordModal";
Amplify.configure(aws_exports);

let apiName = "apide08d634";
let path = "/users";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class SMBForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      businessName: "",
      businessNameError: false,
      address: "",
      addressError: false,
      city: "",
      cityError: false,
      state: "",
      stateError: false,
      zip: "",
      zipError: false,
      phone: "",
      phoneError: false,
      email: "",
      emailError: false,
      service: "",
      accountNumber: "",
      submit: false,
      data: "",
      bill: "",
      mKey: "",
      message: "",
      notification: false,
      loading: false,
      redirect: false,
      newRecord: false,
      response: []
    };
  }
  handleChange(event, type) {
    this.setState({
      [event.target.id]: event.target.value
    });
    switch (type) {
        case "businessName":
            if (event.target.value === "") {
            this.setState({ businessNameError: true });
            } else {
            this.setState({ businessNameError: false });
            }
            break;
        // case "phone":
        //   if (event.target.value !== "") {
        //     this.setState({ phoneError: true });
        //   } else {
        //     this.setState({ phoneError: false });
        //   }
        //   break;
        // case "email":
        //   if (event.target.value === "") {
        //     this.setState({ emailError: true });
        //   } else {
        //     this.setState({ emailError: false });
        //   }
        //   break;
        case "address":
            if (event.target.value === "") {
            this.setState({ addressError: true });
            } else {
            this.setState({ addressError: false });
            }
            break;
        case "city":
            if (event.target.value === "") {
            this.setState({ cityError: true });
            } else {
            this.setState({ cityError: false });
            }
            break;
        case "state":
            if (event.target.value === "") {
            this.setState({ stateError: true });
            } else {
            this.setState({ stateError: false });
            }
            break;
        case "zip":
            if (event.target.value === "") {
            this.setState({ zipError: true });
            } else {
            this.setState({ zipError: false });
            }
            break;
        case "service":
            if (event.target.value === "") {
                this.setState({ serviceError: true });
            } else {
                this.setState({ serviceError: false });
            }
            break;
        case "accountNumber":
            if (event.target.value === "") {
                this.setState({ accountNumberError: true });
            } else {
                this.setState({ accountNumberError: false });
            }
            break;
        default:
            break;
    }
  }
  handleSubmit = async event => {
    event.preventDefault();
    const zipRex = /^\d{5}(?:[-\s]\d{4})?$/;
    const phoneRex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.state.email === "") {
      this.setState({ emailError: false });
    }
    if (this.state.phone === "") {
      this.setState({ phoneError: false });
    }
    if (
      this.state.firstname === "" ||
      this.state.businessName === "" ||
      this.state.address === "" ||
      this.state.city === "" ||
      this.state.state === "" ||
      this.state.zip === "" ||
      (this.state.zip !== "" && !this.state.zip.match(zipRex)) ||
      (this.state.phone !== "" && !this.state.phone.match(phoneRex)) ||
      (this.state.email !== "" && !this.state.email.match(emailRex))
    ) {
      if (this.state.firstname === "") {
        this.setState({ firstnameError: true });
      }
      if (this.state.businessName === "") {
        this.setState({  businessNameError: true });
      }
      if (this.state.address === "") {
        this.setState({ addressError: true });
      }
      if (this.state.city === "") {
        this.setState({ cityError: true });
      }
      if (this.state.state === "") {
        this.setState({ stateError: true });
      }
      if (
        this.state.zip === "" ||
        (this.state.zip !== "" && !this.state.zip.match(zipRex))
      ) {
        this.setState({ zipError: true });
      }
      if (this.state.phone !== "" && !this.state.phone.match(phoneRex)) {
        this.setState({ phoneError: true });
      } else {
        this.setState({ phoneError: false });
      }
      if (this.state.email !== "" && !this.state.email.match(emailRex)) {
        this.setState({ emailError: true });
      }
    } else if ( !this.state.firstnameError && !this.state.businessNameError && !this.state.addressError && !this.state.cityError && !this.state.stateError && !this.state.zipError && !this.state.phoneError && !this.state.emailError ) {
        this.setState({
            submit: true,
            loading: true,
            email: this.state.email,
            firstname: this.state.firstname,
            businessName: this.state.businessName,
            address: this.state.address,
            city: this.state.city
        });
        this.checkMkey();
    }
  };

  checkMkey = () => {
    // console.log("checkMkey")
    let myInit1 = {
      headers: {
        nameLast: this.state.businessName.toUpperCase(),
        address: this.state.address.toUpperCase(),
        zip: this.state.zip
      }
    };
    API.get(apiName, "/checkMkey", myInit1).then(response => {
    //   console.log(response);
      if (response.length > 0) {
        // console.log("qqqqqqqqq")
        this.setState({ mKey: response });
        let myInit2 = {
          headers: {
            mKey: response,
            accountType: "smb"
          }
        };
        API.get(apiName, path, myInit2).then(response => {
        //   console.log(response);
          if (response.length > 1) {
            // console.log(response[0].accounts)
            window.$('#selectRecord').modal('show');
            this.setState({ response: response, loading: false})
            // if(response[0].accounts !== undefined) {
            //     window.$('#selectRecord').modal('show');
            //     this.setState({ response: response, loading: false})
            // } else {
            //     this.setState({ loading: false });
            //     window.$('#newRecord').modal('show');
            // }
          } else if (response.length > 0) {
            // console.log(response[0].accounts)
            if(response[0].accounts !== undefined) {
                window.$('#confirmAccount').modal('show');
                localStorage.setItem("ref", "");           
                localStorage.setItem("mKey", response[0].mKey);
                localStorage.setItem("uniqueKey", response[0].uniqueKey);
                localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
                localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
                localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
                localStorage.setItem("classification", response[0].classification);
                localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
                localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
                localStorage.setItem("smsGlobal", response[0]["preferences"]["global"]["sms"]["status"]);
                localStorage.setItem("emailNewstips", response[0]["preferences"]["newsTips"]["email"]["status"]);
                localStorage.setItem("mailNewstips", response[0]["preferences"]["newsTips"]["mail"]["status"]);
                this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
                this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
                this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
                
                this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });
                
                this.props.dispatch({ type: "ADD_SERVICE", payload: response[0].service_type === undefined ? "-" : response[0].service_type });
                this.props.dispatch({ type: "ADD_ACCOUNT", payload: response[0].accounts === undefined ? "-" : response[0].accounts });            
                
                if (response[0].classification === "DIRECT") {
                    this.setState({ bill: "CONSTELLATION_ENERGY" });
                } else if (response[0].classification === "UTILITY") {
                    this.setState({ bill: "CONSTELLATION_UTILITY_BILLED" });
                }
                this.setState({ data: response, loading: false });
            } else {
                this.setState({ loading: false });
                window.$('#newRecord').modal('show');
            }
          } else if (this.state.phone !== "") {
            this.checkPhone();
          } else if (this.state.email !== "") {
            this.checkEmail();
          } else {
            this.setState({ loading: false });
            window.$('#newRecord').modal('show');
            // this.insertQuery();
          }
        });
      }
    });
  };

  checkPhone() {
    let myInit1 = {
      headers: {
        phone: this.state.phone,
        accountType: "smb"
      }
    };
    // console.log("in checkPhone");
    API.get(apiName, path, myInit1).then(response => {
    //   console.log(response);
    if (response.length > 1) {
        // console.log(response[0].accounts)
        window.$('#selectRecord').modal('show');
        this.setState({ response: response, loading: false})
        // if(response[0].accounts !== undefined) {
        //     window.$('#selectRecord').modal('show');
        //     this.setState({ response: response, loading: false})
        // } else {
        //     this.setState({ loading: false });
        //     window.$('#newRecord').modal('show');
        // }
    } else if (response.length > 0) {
        // console.log(response[0].accounts)
        if(response[0].accounts !== undefined) {
            window.$('#confirmAccount').modal('show');
            localStorage.setItem("ref", "");

            localStorage.setItem("uniqueKey", response[0].uniqueKey);
            localStorage.setItem("mKey", response[0].mKey);
            localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
            localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
            localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
            localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
            localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
               
            localStorage.setItem(
            "smsGlobal",
            response[0]["preferences"]["global"]["sms"]["status"]
            );
            localStorage.setItem(
            "emailNewstips",
            response[0]["preferences"]["newsTips"]["email"]["status"]
            );
            localStorage.setItem(
            "mailNewstips",
            response[0]["preferences"]["newsTips"]["mail"]["status"]
            );
            localStorage.setItem("classification", response[0].classification);
            this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
                
            this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
                
            this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });

            this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
            this.props.dispatch({ type: "ADD_SERVICE", payload: response[0].service_type === undefined ? "-" : response[0].service_type });
            this.props.dispatch({ type: "ADD_ACCOUNT", payload: response[0].accounts === undefined ? "-" : response[0].accounts });            
            
            if (response[0].classification === "DIRECT") {
            this.setState({ bill: "CONSTELLATION_ENERGY" });
            } else if (response[0].classification === "UTILITY") {
            this.setState({ bill: "CONSTELLATION_UTILITY_BILLED" });
            }
            this.setState({ data: response, loading: false });
        } else if (this.state.email !== "") {
            this.checkEmail();
        } else if (this.state.email === "") {
            this.setState({ loading: false });
            window.$('#newRecord').modal('show');
        }
      } else if (this.state.email !== "") {
        this.checkEmail();
      } else if (this.state.email === "") {
        this.setState({ loading: false });
        window.$('#newRecord').modal('show');
        // this.insertQuery();
      }
    });
  }

  checkEmail() {
    let myInit1 = {
      headers: {
        email: this.state.email.toLowerCase(),
        accountType: "smb"
      }
    };
    // console.log("in checkEmail");
    API.get(apiName, path, myInit1).then(response => {
    //   console.log(response);
    if (response.length > 1) {
        window.$('#selectRecord').modal('show');
        this.setState({ response: response, loading: false})
        // console.log(response[0].accounts)
        // if(response[0].accounts !== undefined) {
        //     window.$('#selectRecord').modal('show');
        //     this.setState({ response: response, loading: false})
        // } else {
        //     this.setState({ loading: false });
        //     window.$('#newRecord').modal('show');
        // }
      } else if (response.length > 0) {
        // console.log(response[0].accounts)
        if(response[0].accounts !== undefined) {
            window.$('#confirmAccount').modal('show');
            localStorage.setItem("ref", "");
            localStorage.setItem("mKey", response[0].mKey);
            localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
            localStorage.setItem("uniqueKey", response[0].uniqueKey);
            localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
            localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
            localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
            localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
               
            localStorage.setItem(
            "smsGlobal",
            response[0]["preferences"]["global"]["sms"]["status"]
            );
            localStorage.setItem(
            "emailNewstips",
            response[0]["preferences"]["newsTips"]["email"]["status"]
            );
            localStorage.setItem(
            "mailNewstips",
            response[0]["preferences"]["newsTips"]["mail"]["status"]
            );
            localStorage.setItem("classification", response[0].classification);
            this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
            this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });   
            this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
                
            this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });
            this.props.dispatch({ type: "ADD_SERVICE", payload: response[0].service_type === undefined ? "-" : response[0].service_type });
            this.props.dispatch({ type: "ADD_ACCOUNT", payload: response[0].accounts === undefined ? "-" : response[0].accounts });            
             
            if (response[0].classification === "DIRECT") {
            this.setState({ bill: "CONSTELLATION_ENERGY" });
            } else if (response[0].classification === "UTILITY") {
            this.setState({ bill: "CONSTELLATION_UTILITY_BILLED" });
            }
            this.setState({ data: response, loading: false });
        } else if (this.state.email !== "") {
            this.setState({ loading: false });
            window.$('#newRecord').modal('show');
        }
      } else if (this.state.email !== "") {
        this.setState({ loading: false });
        window.$('#newRecord').modal('show');
      }
    });
  }

//   insertQuery = () => {
//     const uuidv4 = require("uuid/v4");
//     let uuid = uuidv4();
//     this.setState({ lastModifiedDate: new Date().toJSON() });
//     let myInit2 = {
//       body: {
//         uniqueKey: uuid,
//         referenceId: uuid.substring(0,8),
//         mKey: this.state.mKey,
//         contact: {
//           nameLast: this.state.businessName.toUpperCase(),
//           updated: this.state.lastModifiedDate
//         },
//         serviceAddress: {
//           address: this.state.address.toUpperCase(),
//           city: this.state.city.toUpperCase(),
//           state: this.state.state,
//           zip: this.state.zip,
//           updated: this.state.lastModifiedDate
//         },
//         lastModifiedDate: this.state.lastModifiedDate,
//         classification: "UTILITY",
//         preferences: {
//           global: {
//             sms: { status: "0", updated: this.state.lastModifiedDate }
//           },
//           newsTips: {
//             email: { status: "0", updated: this.state.lastModifiedDate },
//             mail: { status: "0", updated: this.state.lastModifiedDate }
//           }
//         }
//       }
//     };
//     if (this.state.email !== "") {
//       myInit2['body']['email'] = this.state.email.toLowerCase()
//     }
//     if (this.state.phone !== "") {
//       myInit2['body']['phone'] = this.state.phone
//     }
//     console.log("in insertQuery");
//     API.post(apiName, path, myInit2)
//         .then(response => {
//             localStorage.setItem("uniqueKey", response["uniqueKey"]);
//             localStorage.setItem("ref", "");
//             localStorage.setItem("mKey", this.state.mKey);
//             localStorage.setItem("nameFirst", this.state.firstname);
//             localStorage.setItem("nameLast", this.state.businessName);
//             localStorage.setItem("lastModifiedDate", this.state.lastModifiedDate);
//             this.props.dispatch({ type: "ADD_PHONE", payload: this.state.phone === "" ? "-" : this.state.phone });
//             this.props.dispatch({ type: "ADD_EMAIL", payload: this.state.email === "" ? "-" : this.state.email });
            
//             this.props.dispatch({ type: "ADD_STREET", payload: this.state.address === "" ? "-" : this.state.address });
//             localStorage.setItem("city", this.state.city);
//             localStorage.setItem("state", this.state.state);
//             this.props.dispatch({ type: "ADD_ZIP", payload: this.state.zip === "" ? "-" : this.state.zip });
//             localStorage.setItem("smsGlobal", "0");
//             localStorage.setItem("emailNewstips", "0");
//             localStorage.setItem("mailNewstips", "0");
//             localStorage.setItem("classification", "UTILITY");
//             this.setState({
//             redirect: true,
//             loading: false,
//             bill: "CONSTELLATION_UTILITY_BILLED"
//             });
//         })
//         .catch(error => {
//             console.log(error);
//         });
//     };

    selectedRecord = (key) => {
        // console.log(key);
        let myInit1 = {
            headers: {
              uniqueKey: key
            }
        };
        // console.log("in selectedRecord");
        window.$('#selectRecord').modal('hide');
        window.$('#confirmAccount').modal('show');
        API.get(apiName, path, myInit1).then(response => {
            // console.log(response);
            localStorage.setItem("ref", "");           
            localStorage.setItem("mKey", response[0].mKey);
            localStorage.setItem("uniqueKey", key);
            localStorage.setItem("nameLast", response[0]["contact"]["nameLast"]);
            localStorage.setItem("nameFirst", response[0]["contact"]["nameFirst"]);
            localStorage.setItem("lastModifiedDate", response[0].lastModifiedDate);
            localStorage.setItem("classification", response[0].classification);
            
            
  
            localStorage.setItem("city", response[0]["serviceAddress"]["city"]);
            localStorage.setItem("state", response[0]["serviceAddress"]["state"]);
            localStorage.setItem("smsGlobal", response[0]["preferences"]["global"]["sms"]["status"]);
            localStorage.setItem("emailNewstips", response[0]["preferences"]["newsTips"]["email"]["status"]);
            localStorage.setItem("mailNewstips", response[0]["preferences"]["newsTips"]["mail"]["status"]);
            this.props.dispatch({ type: "ADD_ZIP", payload: response[0]["serviceAddress"]["zip"] });
            this.props.dispatch({ type: "ADD_STREET", payload: response[0]["serviceAddress"]["address"] === undefined ? "-" : response[0]["serviceAddress"]["address"] });
            this.props.dispatch({ type: "ADD_PHONE", payload: response[0].phone === undefined ? "-" : response[0].phone });
            
            this.props.dispatch({ type: "ADD_EMAIL", payload: response[0].email === undefined ? "-" : response[0].email });
            
            this.props.dispatch({ type: "ADD_SERVICE", payload: response[0].service_type === undefined ? "-" : response[0].service_type });
            this.props.dispatch({ type: "ADD_ACCOUNT", payload: response[0].accounts === undefined ? "-" : response[0].accounts });            
            
            if (response[0].classification === "DIRECT") {
              this.setState({ bill: "CONSTELLATION_ENERGY" });
            } else if (response[0].classification === "UTILITY") {
              this.setState({ bill: "CONSTELLATION_UTILITY_BILLED" });
            }
            this.setState({ data: response, loading: false });
        });
        // this.confirmAccount
    }
    confirmAccount = event => {
        event.preventDefault();
        if(this.state.service === "" || this.state.accountNumber === "") {
            if(this.state.service === "") {
                this.setState({ serviceError: true })
            }
            if(this.state.accountNumber === "") {
                this.setState({ accountNumberError: true })
            }
        } else {
            // console.log(this.props.reduxAccount.includes(this.state.accountNumber))
            if(this.state.service === this.props.reduxService && this.props.reduxAccount.includes(this.state.accountNumber)) {
                // console.log("equal")
                window.$('#confirmAccount').modal('hide');
                localStorage.setItem("ref", "true");
                this.setState({ redirect: true })
            } else {
                this.setState({ message: "Service or Account number you entered is invalid."})
                this.showNotification();
            }
            // let myInit1 = {
            //     headers: {
            //       uniqueKey: localStorage.getItem("uniqueKey")
            //     }
            // };
            // console.log("in confirm account");
            // API.get(apiName, path, myInit1).then(response => {
                // console.log(response);
            //     console.log(response[0].service_type);
            //     console.log(response[0].accounts.includes(this.state.accountNumber))
            //     if(this.state.service === response[0].service_type && response[0].accounts.includes(this.state.accountNumber)) {
            //         console.log("equal")
            //         window.$('#confirmAccount').modal('hide');
            //         this.setState({ redirect: true })
            //     } else {
            //         this.setState({ message: "Service or Account number you entered is invalid."})
            //         this.showNotification();
            //     }
            // });
        }
    }
    showNotification = () => {
        // console.log("notification");
        this.setState({notification: true})
        setTimeout(
          function() {
            this.setState({notification: false});
          }.bind(this),
          2500
        );
    }

  render() {
    // console.log(this.state.accountNumber);
    if (this.state.submit) {
    //   console.log("submit");
      if (this.state.address !== "") {
        // this.checkMkey();
      }
    //   this.setState({ submit: false });
    }
    if (this.state.redirect) {
    //   console.log(this.state.bill);
      this.props.history.push({
        pathname: "/update",
        search: "?ProgramGroupID=" + this.state.bill
      });
    }
    return (
      <React.Fragment>
        <Header/>
        <main className="locateprefs">
        <div className={this.state.notification ? "snackbarHidden snackbarShow" : "snackbarHidden"} style={{backgroundColor: "#d10808"}}>{this.state.message}</div>
            <div className="container loginFont">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-6 loginForm">
                        <h3 className="text-left"  style={{ color: "#81CFE7", fontWeight: "bold" }}>Locate My Preferences</h3>
                        <form
                            id="login-form"
                            className="form-horizontal"
                            onSubmit={this.handleSubmit}
                            style={{ padding: "15px" }}
                        >
                            <br />
                            <div className="row">
                                <div className="col-12">
                                    <div className="formInput">
                                        <label className="col-4 control-label ">*Business Name:</label>
                                        <input
                                            className="form-control col-8 loginInput pull-right "
                                            id="businessName"
                                            name="businessName"
                                            type="text"
                                            onChange={event => this.handleChange(event, "businessName")}
                                            value={this.state.businessName}
                                        />
                                    </div>
                                    <div className={this.state.businessNameError ? "col-12 text-right error fontSmall" : "hidden"}>
                                        Please provide a valid businessName.
                                    </div>

                                    <div className="formInput">
                                        <label className="col-4 control-label ">*Service Address:</label>
                                        <input
                                            className="form-control col-8 loginInput pull-right "
                                            id="address"
                                            name="ContactElementInfo.Address"
                                            type="text"
                                            onChange={event => this.handleChange(event, "address")}
                                            value={this.state.address}
                                        />
                                    </div>
                                    <div className={this.state.addressError ? "col-12 text-right error fontSmall" : "hidden"}>
                                        Please provide a valid address.
                                    </div>

                                    <div className="formInput">
                                        <label className="col-4 control-label ">*City: </label>
                                        <input
                                            className="form-control col-8 loginInput pull-right "
                                            id="city"
                                            name="ContactElementInfo.City"
                                            type="text"
                                            onChange={event => this.handleChange(event, "city")}
                                            value={this.state.city}
                                        />
                                    </div>
                                    <div className={this.state.cityError ? "col-12 text-right error fontSmall" : "hidden"}>
                                        Please provide a valid city.
                                    </div>

                                    <div className="formInput">
                                        <label className="col-4 control-label ">*State/Province:</label>
                                        <select
                                            className="form-control col-8 loginInput pull-right "
                                            id="state"
                                            name="ContactElementInfo.State"
                                            onChange={event => this.handleChange(event, "state")}
                                            value={this.state.state}
                                        >
                                            <option value="">Select State/Province</option>
                                            <option value="AL">AL</option>
                                            <option value="AK">AK</option>
                                            <option value="AZ">AZ</option>
                                            <option value="AR">AR</option>
                                            <option value="CA">CA</option>
                                            <option value="CO">CO</option>
                                            <option value="CT">CT</option>
                                            <option value="DE">DE</option>
                                            <option value="DC">DC</option>
                                            <option value="FL">FL</option>
                                            <option value="GA">GA</option>
                                            <option value="HI">HI</option>
                                            <option value="ID">ID</option>
                                            <option value="IL">IL</option>
                                            <option value="IN">IN</option>
                                            <option value="IA">IA</option>
                                            <option value="KS">KS</option>
                                            <option value="KY">KY</option>
                                            <option value="LA">LA</option>
                                            <option value="ME">ME</option>
                                            <option value="MD">MD</option>
                                            <option value="MA">MA</option>
                                            <option value="MI">MI</option>
                                            <option value="MN">MN</option>
                                            <option value="MS">MS</option>
                                            <option value="MO">MO</option>
                                            <option value="MT">MT</option>
                                            <option value="NE">NE</option>
                                            <option value="NV">NV</option>
                                            <option value="NH">NH</option>
                                            <option value="NJ">NJ</option>
                                            <option value="NM">NM</option>
                                            <option value="NY">NY</option>
                                            <option value="NC">NC</option>
                                            <option value="ND">ND</option>
                                            <option value="OH">OH</option>
                                            <option value="OK">OK</option>
                                            <option value="OR">OR</option>
                                            <option value="PA">PA</option>
                                            <option value="RI">RI</option>
                                            <option value="SC">SC</option>
                                            <option value="SD">SD</option>
                                            <option value="TN">TN</option>
                                            <option value="TX">TX</option>
                                            <option value="UT">UT</option>
                                            <option value="VT">VT</option>
                                            <option value="VA">VA</option>
                                            <option value="WA">WA</option>
                                            <option value="WV">WV</option>
                                            <option value="WI">WI</option>
                                            <option value="WY">WY</option>
                                        </select>
                                    </div>
                                    <div className={this.state.stateError ? "col-12 text-right error fontSmall" : "hidden"}>
                                        Please provide a valid state.
                                    </div>
                                    <div className="formInput">
                                        <label className="col-4 control-label ">*Zip/PostalCode:</label>
                                        <input
                                            className="form-control col-8 loginInput pull-right "
                                            id="zip"
                                            name="ContactElementInfo.Mail"
                                            type="text"
                                            onChange={event => this.handleChange(event, "zip")}
                                            value={this.state.zip}
                                        />
                                    </div>
                                    <div className={this.state.zipError ? "col-12 text-right error fontSmall" : "hidden"}>
                                        Please provide a valid zip.
                                    </div>

                                    <div className="formInput">
                                        <label className="col-4 control-label ">Phone: </label>
                                        <input
                                            className="form-control col-8 loginInput pull-right "
                                            id="phone"
                                            name="ContactElementInfo.Phone"
                                            type="text"
                                            onChange={event => this.handleChange(event, "phone")}
                                            value={this.state.phone}
                                        />
                                    </div>
                                    <div className={this.state.phoneError ? "col-12 text-right error fontSmall" : "hidden"}>
                                        Please provide a valid phone.
                                    </div>

                                    <div className="formInput">
                                        <label className="col-4 control-label ">Email: </label>
                                        <input
                                            className="form-control col-8 loginInput pull-right "
                                            id="email"
                                            name="ContactElementInfo.Email"
                                            type="text"
                                            onChange={event => this.handleChange(event, "email")}
                                            value={this.state.email}
                                        />
                                    </div>
                                    <div className={this.state.emailError ? "col-12 text-right error fontSmall" : "hidden"}>
                                        Please provide a valid email.
                                    </div>
                                </div>
                            </div>
                            <div className="form-group text-center">
                                <br />
                                <button
                                    style={{ minWidth: "150px" }}
                                    type="submit"
                                    name="submit"
                                    className={this.state.loading ? "hidden" : "btn btn-primary"}
                                    id="search"
                                    
                                >
                                    Search
                                </button>
                                <div
                                    className={this.state.loading ? "sweet-loading" : "hidden"}
                                >
                                    <ScaleLoader
                                        className={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={"rgb(244, 123, 39)"}
                                        loading={this.state.loading}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="newRecord"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="newRecordTitle"
                    aria-hidden="true"
                >
                    <div className="modal-dialog ">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5
                                    className="modal-title text-center fontLarge"
                                    id="newRecordTitle"
                                >
                                    No Record
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body fontMedium text-justify">
                                <p className="text-center">
                                    No record found with the given details.<br/>
                                </p>
                                <p className="text-center">
                                    Please contact Constellation Customer Service at (877) 677-4355
                                </p>
                                {/* <p className="text-center">
                                    Do you like to create a new record?
                                </p> */}
                            </div>
                            {/* <div className="modal-footer">
                                <div className=" col-12 text-center">
                                    <button
                                        type="button"
                                        className="disagreeButton"
                                        data-dismiss="modal"
                                        style={{ marginRight: "10px", marginBottom: "10px" }}
                                    >
                                        CANCEL
                                    </button>
                                    <button
                                        type="button"
                                        className="modalButton"
                                        style={{ marginBottom: "10px" }}
                                        onClick={this.insertQuery}
                                        data-dismiss="modal"
                                    >
                                        CREATE
                                    </button>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="confirmAccount"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="confirmAccountTitle"
                    aria-hidden="true"
                >
                    <div className="modal-dialog ">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title text-center fontLarge" id="confirmAccountTitle">
                                    Confirm your account
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body fontMedium text-justify">
                                <p className="text-left">
                                    Please confirm your account by completing the information below.
                                </p>
                                <form className="">
                                    <div className="">
                                        <div className="formInput">
                                            <div>
                                                <label className="">Service provided: </label>
                                            </div>
                                            <div>
                                                <select 
                                                    className="form-control mailInput" 
                                                    id="service" 
                                                    name="ContactElementInfo.service" 
                                                    value={this.state.service}
                                                    onChange={event => this.handleChange(event, "service")}
                                                >
                                                    <option value="">Select...</option>
                                                    <option value="POWER">POWER</option>
                                                    <option value="GAS">GAS</option>
                                                    <option value="BOTH">BOTH</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className={this.state.serviceError ? "error fontSmall text-left" : "hidden"}>
                                            select valid service.
                                        </div>
                                        <div className="formInput">
                                            <div>
                                                <label className="">Enter a valid account number: </label>
                                            </div>
                                            <div>
                                                <input
                                                    className="form-control mailInput"
                                                    id="accountNumber"
                                                    name="accountNumber"
                                                    type="text"
                                                    onChange={event => this.handleChange(event, "accountNumber")}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                                <label className=""><b>(this number is found on your electricity or natural gas bill)</b> </label>
                                            </div>
                                        <div className={this.state.accountNumberError ? "error fontSmall text-left" : "hidden"}>
                                            enter valid account number.
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <div className="">
                                    <button
                                        type="button"
                                        className="disagreeButton"
                                        data-dismiss="modal"
                                        style={{ marginRight: "10px", marginBottom: "10px" }}
                                    >
                                        CANCEL
                                    </button>
                                    <button
                                        type="button"
                                        className="modalButton"
                                        style={{ marginBottom: "10px" }}
                                        onClick={this.confirmAccount}
                                        // data-dismiss="modal"
                                    >
                                        SUBMIT
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SelectRecordModal data={this.state.response} selectedRecord={key => this.selectedRecord(key)} />
            </div>
        </main>
        <Footer/>
      </React.Fragment>
    );
  }
}


const mapStateToProps = state => ({
  reduxEmail: state.reduxEmail,
  reduxPhone: state.reduxPhone,
  reduxStreet: state.reduxStreet,
  reduxZip: state.reduxZip,
  reduxService: state.reduxService,
  reduxAccount: state.reduxAccount
});

export default connect(mapStateToProps)(SMBForm);



// WEBPACK FOOTER //
// ./src/views/CustomerPages/SMBForm.jsx